module.exports = __webpack_public_path__ + "img/404.15e5b47c.svg";